import { AiUploadedDocument } from './AiUploadDocumentSection'
import { AiUploadedImage } from './AiUploadImageSection'
import type { UploadedAttachmentState } from './aiDataExtractionRequest'

export const hasSelectedAttachments = (
  images: AiUploadedImage[],
  floorPlanDocument: AiUploadedDocument | null,
  energyCertificateDocument: AiUploadedDocument | null
) => images.length > 0 || floorPlanDocument !== null || energyCertificateDocument !== null

export const hasPendingUploads = (
  uploadedImageAttachments: Record<string, UploadedAttachmentState>,
  uploadedFloorPlanAttachment: UploadedAttachmentState | null,
  uploadedEnergyCertificateAttachment: UploadedAttachmentState | null
) =>
  Object.values(uploadedImageAttachments).some((attachmentState) => attachmentState.status === 'uploading') ||
  uploadedFloorPlanAttachment?.status === 'uploading' ||
  uploadedEnergyCertificateAttachment?.status === 'uploading'
